import { render } from "./PagetreeSearch.vue?vue&type=template&id=ffecdfce&scoped=true"
import script from "./PagetreeSearch.vue?vue&type=script&lang=js"
export * from "./PagetreeSearch.vue?vue&type=script&lang=js"

import "./PagetreeSearch.vue?vue&type=style&index=0&id=ffecdfce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffecdfce"]])

export default __exports__